import { useHistory } from 'react-router-dom'
import { useModalBox } from '../../contexts'
import Button from '../button'
import * as S from './styles'
type Props = {
  idCustomer: number | string
  cdServico: number | string
}

const AlertModal = ({ idCustomer, cdServico }: Props) => {
  const history = useHistory()
  const { modalClose } = useModalBox()
  return (
    <S.Wrapper>
      <div className="delete-modal">
        <p>
          Deseja preencher a entrevista atual com as informações da entrevista
          anterior mais recente?
        </p>
        <div>
          <Button
            hasredButton
            onClick={() => {
              modalClose()
              history.push(
                `/meus-pacientes/${idCustomer}/avaliacao-psicologica/entrevista/${cdServico}/${true}`
              )
            }}
          >
            Sim
          </Button>
          <Button
            hasSecodaryButton
            onClick={() => {
              modalClose()
              history.push(
                `/meus-pacientes/${idCustomer}/avaliacao-psicologica/entrevista/${cdServico}/${false}`
              )
            }}
          >
            Não
          </Button>
        </div>
      </div>
    </S.Wrapper>
  )
}
export default AlertModal
